module.exports = __webpack_public_path__ + "static/media/2 (51).157fc806.jpg";